import { fetchCategories } from 'hb-react/frontoffice/apps/NewsIndex/requests/fetchCategories';
import { type Config } from 'hb-react/frontoffice/apps/NewsIndex/types';
import { ITEMS_QUERY_KEYS } from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/utils/queryUtils';
import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import oneColumnTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/OneColumnTemplate';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';

export const newsCategoryTags = ({ config }: { config: Config }) => ({
  ...BLOCKS.tags,
  attributes: {
    queryId: ITEMS_QUERY_KEYS.news.tags,
    fetchTags: () => fetchCategories(config.routes.categories_url),
    multi: true,
    showAllTag: true,
  },
  templateAttributes: {
    [oneColumnTemplate.id]: {
      limit: 10,
    },
    [twoColumnsTemplate.id]: {
      label: s__('News|Filter by category'),
      limit: 15,
    },
  },
});
